import { useSplitEnabled } from '@buffer-mono/features'

import { PublicGraphQLApiModalDialog } from './PublicGraphQLApiModalDialog'

import type { JSX } from 'react'

/**
 * Split-gated wrapper for the API GA launch announcement modal.
 *
 * Renders nothing until the `public-graphql-api-modal` split has loaded and is
 * enabled. The dialog itself handles one-time dismissal and audience targeting.
 */
export function PublicGraphQLApiModal(): JSX.Element | null {
  const { isEnabled, isReady } = useSplitEnabled('public-graphql-api-modal')

  if (!isReady || !isEnabled) {
    return null
  }

  return <PublicGraphQLApiModalDialog />
}
